module.exports = __webpack_public_path__ + "img/db28030.jpg";